import { AfterViewInit, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { switchMap } from 'rxjs';
import { environment } from '../environments/environment';
import { CookieConsentService } from './core/cookie/cookie-consent.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit, AfterViewInit {
    readonly titleService = inject(Title);
    readonly destroyRef = inject(DestroyRef);
    readonly translocoService = inject(TranslocoService);
    readonly cookieConsentService = inject(CookieConsentService);

    /**
     * Constructor
     */
    constructor() {}

    ngOnInit() {
        this.titleService.setTitle(environment.tabTitle ?? 'Fidelity');
    }

    ngAfterViewInit(): void {
        this.translocoService.langChanges$
            .pipe(
                switchMap((lang) => this.translocoService.load(lang)), //force load of language, in order to have the translations ready.
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(() => {
                //Every time the language changes, update the cookie consent.
                this.cookieConsentService.initCookieConsent();
            });
    }
}
